const STACKED_QUERY = '(max-width: 1199px)';

const setActiveItem = (section, item) => {
	if (!item) {
		return;
	}

	section.querySelectorAll('.milestones__item').forEach((other) => {
		const isActive = other === item;
		const button = other.querySelector('.milestones__marker');
		const card = other.querySelector('.milestones__card');

		other.classList.toggle('is-active', isActive);
		button?.setAttribute('aria-expanded', isActive ? 'true' : 'false');
		card?.setAttribute('aria-hidden', isActive ? 'false' : 'true');
	});

	if (window.matchMedia(STACKED_QUERY).matches) {
		window.setTimeout(() => {
			item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}, 120);
	}
};

const initMilestones = (section) => {
	section.querySelectorAll('.milestones__marker').forEach((button) => {
		button.addEventListener('click', () => {
			const item = button.closest('.milestones__item');

			if (!item || item.classList.contains('milestones__item--no-card')) {
				return;
			}

			setActiveItem(section, item);
		});
	});
};

const boot = () => {
	document.querySelectorAll('.milestones').forEach((section) => {
		initMilestones(section);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
